import { TreatmentReasonDto, TreatmentReasonSearchRequest, UpsertTreatmentReasonDto } from 'ts-types/api.types';
import axios from './http';
import { CancelTokenSource } from 'axios';

const { REACT_APP_API_BASE_URL: baseUrl } = process.env;
const apiUri = `${baseUrl}/api/treatment-reasons`;

export const getAllTreatmentReasons = (source: CancelTokenSource): Promise<Array<TreatmentReasonDto>> => {
  return axios
      .get(apiUri, {cancelToken: source.token})
      .then(response => response.data);
};

export const searchTreatmentReasons = (treatmentReasonsSearchRequest: Partial<TreatmentReasonSearchRequest>,
                                                                source: CancelTokenSource): Promise<Array<TreatmentReasonDto>> => {
  return axios
      .post( `${apiUri}/search`, treatmentReasonsSearchRequest, {cancelToken: source.token})
      .then(response => response.data)
};

export const findTreatmentReasonById = (id: number, source: CancelTokenSource): Promise<UpsertTreatmentReasonDto> => {
  return axios
      .get(`${apiUri}/${id}`, {cancelToken: source.token})
      .then(response => response.data)
};

export const  addTreatmentReason = (upsertTreatmentReasonDto: Partial<UpsertTreatmentReasonDto>,
                                    source: CancelTokenSource): Promise<TreatmentReasonDto> => {
  return axios
      .post(apiUri, upsertTreatmentReasonDto, {cancelToken: source.token})
      .then(response => response.data);
};

export const editTreatmentReason = (id: number, upsertTreatmentReasonDto: Partial<UpsertTreatmentReasonDto>,
                                    source: CancelTokenSource): Promise<TreatmentReasonDto> => {
  return axios
      .put(`${apiUri}/${id}`,upsertTreatmentReasonDto, {cancelToken: source.token})
      .then(response => response.data)
};

export const deleteTreatmentReason = (id: number, source: CancelTokenSource): Promise<TreatmentReasonDto> => {
  return axios
      .delete(`${apiUri}/${id}`, {cancelToken: source.token})
      .then(response => response.data);
};
